import React from "react";

import { useMediaQuery } from "react-responsive";
import { BrowserRouter as Router, Link } from "react-router-dom";
const SectionSix = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div
      className={isMobile ? "section-six-pricing-mob" : "section-six-pricing"}
    >
      <div style={{ maxWidth: "600px" }}>
        <h1 className="sec-six-heading-pricing">
          Turn browsers into buyers and buyers into loyal customers — start
          today.
        </h1>
        <a
          href="https://apps.shopify.com/kwikengage?utm_source=pricingpage&utm_medium=shopify"
          target="_blank"
          style={{ color: "black" }}
        >
          <div className="pricing-btn-grp">
            <button className="cta1a-install-shoppy">
              Install Free Shopify App
            </button>
            <Link to="/contact" style={{ color: "white" }}>
              <div className="cta1a-Ind-price">Book a Demo</div>
            </Link>
          </div>
        </a>
      </div>
      <div>
        <img
          className="aim-image"
          src="assets/images/kwikpricing/aim.png"
          alt=""
        />
      </div>
    </div>
  );
};

export default SectionSix;
